var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.row.status !== 'paid')?_c('button',{staticClass:"btn btn-block btn-sm btn-primary disabled",attrs:{"aria-disabled":"true","disabled":""}},[_vm._v("Pending")]):_c('a',{staticClass:"btn btn-block btn-sm btn-primary",attrs:{"href":_vm.$api + _vm.row.url,"download":""}},[_vm._v("Download")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b3c8e80","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataTableFields/Download.vue
// module id = 739
// module chunks = 30